import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Form, Input, Button, notification, Modal } from "antd";
import authAction from "../../redux/auth/actions";
import "./index.css";

const { login } = authAction;

function SignIn() {
  const dispatch = useDispatch();

  const { idToken, accessInformation } = useSelector(
    (state) => state.authReducer
  );

  useEffect(() => {
    if (idToken) {
      // Redirect to the first Url from accessInformation
      if (accessInformation.length !== 0) {
        window.location = `/${accessInformation[0].urls[0].url}`;
      } else {
        window.location = "/permission-denied";
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToken]);

  const onFinish = (user) => {
    dispatch(login(user));
  };

  const onFinishFailed = (errorInfo) => {
    notification["error"]({
      message: "Грешка",
      description: "Моля попълнете корeктни данни.",
    });
  };

  return (
    <div className="sign-in-container">
      <Modal
        title={<div className="sign-in-title">ВХОД</div>}
        open={true}
        footer={null}
        closable={false}
      >
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            className="sign-in-form-item-container"
            name="email"
            rules={[
              {
                required: true,
                message: "Email е задължителен!",
              },
              {
                type: "email",
                message: "Невалиден Email!",
              },
            ]}
          >
            <Input placeholder="Email" size="large" className="sign-in-input" />
          </Form.Item>

          <Form.Item
            className="sign-in-form-item-container"
            name="password"
            rules={[
              {
                required: true,
                message: "Моля въведете парола!",
              },
              {
                min: 6,
                message: "Паролата трябва да бъде минимум 6 символа!",
              },
            ]}
          >
            <Input.Password
              placeholder="Парола"
              size="large"
              className="sign-in-input"
            />
          </Form.Item>

          <Form.Item className="sign-in-form-item-container">
            <Button type="primary" htmlType="submit" id="sign-in-login-button">
              Вход
            </Button>
          </Form.Item>
        </Form>

        <div className="sign-in-other-actions">
          <Link to="/forgotpassword" className="sign-in-forgot-password">
            Забравена парола?
          </Link>
          {/* <a href="/signup">Създайте TouchSale Portal акаунт</a> */}
          <Link to="/signup">Създайте TouchSale Portal акаунт</Link>
        </div>
      </Modal>
    </div>
  );
}

export default SignIn;
